/*
 * Whole-bundle remove (markup: snippets/cart-jux-bundle.liquid, used by the
 * drawer and the cart page). POSTs every line key → 0 to /cart/update.js.
 * On the cart page it reloads (the page sections re-render server-side); in the
 * cart drawer it re-renders the drawer + icon bubble in place, no reload.
 * Delegated on document to survive AJAX re-renders.
 */
(function () {
  if (window.__bundleCartRemoveInit) return;
  window.__bundleCartRemoveInit = true;

  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-bundle-cart-remove]');
    if (!button || button.disabled) return;
    event.preventDefault();

    const keys = (button.dataset.bundleKeys || '')
      .split(',')
      .map((key) => key.trim())
      .filter(Boolean);
    if (!keys.length) return;

    button.disabled = true;
    const updates = {};
    keys.forEach((key) => {
      updates[key] = 0;
    });

    const config =
      typeof fetchConfig === 'function'
        ? fetchConfig('json')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };

    const url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    const drawer = document.querySelector('cart-drawer');
    const onCartPage = document.getElementById('main-cart-items');

    const showError = function () {
      button.disabled = false;
      const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
      if (errors && window.cartStrings) errors.textContent = window.cartStrings.error;
    };

    /* Cart page: the page's own sections need re-rendering — reload is the simple, correct path. */
    if (!drawer || onCartPage) {
      config.body = JSON.stringify({ updates });
      fetch(url, config)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          window.location.reload();
        })
        .catch(showError);
      return;
    }

    /* Drawer: re-render its sections in place. */
    config.body = JSON.stringify({
      updates,
      sections: drawer.getSectionsToRender().map(function (section) {
        return section.id;
      }),
      sections_url: window.location.pathname,
    });
    fetch(url, config)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (state) {
        if (!state.sections) throw new Error('missing sections');
        drawer.getSectionsToRender().forEach(function (section) {
          const element = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);
          element.innerHTML = drawer.getSectionInnerHTML(state.sections[section.id], section.selector);
        });
        drawer.classList.toggle('is-empty', state.item_count === 0);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-bundle' });
        }
      })
      .catch(showError);
  });
})();
